import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74be594a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "debug-view" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Reset Game")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Display introduction text on the wall", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Skip Intro")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In Game!", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { useAppState, useGameState } from '@/services/composition';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { send } = useAppState()
const state = useGameState()

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "Game state : " + _toDisplayString(_unref(state).value), 1),
    _createVNode(_component_ui_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_RESET')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_unref(state).matches('intro'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_ui_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('GAME_INTRO_ENDED')))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('game'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}
}

})